<template>
  <div style="padding: 1px 0px">
    <Header :title="'在线纪念'" />
    <div class="container">
      <div class="mv-container box">
        <div class="box-title">相册MV</div>
        <div class="box-content">
          <div class="list">
            <div v-for="item of videos" :key="item.id" class="item">
              <video
                :poster="require('@/assets/images/default.jpg')"
                :src="$resUrl(item.url)"
                controls="controls"
              />
            </div>
          </div>
        </div>
        <div v-show="!videos.length" class="noData">暂无数据</div>
      </div>
      <div class="photo-container box">
        <div class="box-title">相册</div>
        <div class="box-content">
          <div class="list photo-list">
            <div v-for="item of albums" :key="item.id" class="item" @click="openPreview(item.id)">
              <img
                :class="{ thumbnail: item.thumbnail === '/Content/images/Thumbnail.png' }"
                :src="$resUrl(item.thumbnail)"
                alt
                class="normal"
                @error="$defImg(require('@/assets/images/default.jpg'))"
              >
            </div>
          </div>
        </div>
        <div v-show="!albums.length" class="noData">暂无数据</div>
      </div>
    </div>
    <div v-if="hasPower === 3" class="button-box">
      <div class="btn" @click="createPhoto">创建相册</div>
    </div>
    <van-image-preview v-model="showImages" :images="images" />
    <Footer :active="2" />
  </div>
</template>

<script>
import Vue from 'vue'
import { ImagePreview } from 'vant'
import { Toast } from '@nutui/nutui'
import { CheckPower, GetPhotoData, GetPhotoImages } from '@/api/Hall/index'
import Footer from './components/Footer'
import Header from '@/components/Header/Index'
import { mapActions, mapState } from 'vuex'

Vue.use(ImagePreview)

export default {
  name: 'HallPhoto',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      videos: [],
      albums: [],
      images: [],
      showImages: false,
      options3: {
        controls: true,
        muted: true
      }
    }
  },
  computed: {
    ...mapState(['hasPower'])
  },
  mounted() {
    this.getPower()
    this.getPhoto()
  },
  methods: {
    ...mapActions(['setPower']),
    getPower() {
      const { id } = this.$route.params
      CheckPower(id).then(res => {
        const { desc } = res.data
        if (desc === '请先登录') {
          this.setPower(1)
        }
        if (desc === '没有权限') {
          this.setPower(2)
        }
        if (desc === '有权限') {
          this.setPower(3)
        }
      })
    },
    getPhoto() {
      const id = this.$route.params.id
      GetPhotoData(id).then(res => {
        this.videos = res.data.videos
        this.albums = res.data.albums
      })
    },
    createPhoto() {
      this.$router.push({
        name: 'manageHallAlbum',
        id: this.$route.params.id
      })
    },
    openPreview(id) {
      this.images = []
      GetPhotoImages(id).then(res => {
        res.data.forEach(item => {
          const url = this.$resUrl(item.url)
          this.images.push(url)
        })
        // console.log(this.images,'this.images')
        if (this.images.length > 0) {
          this.showImages = true
        } else {
          Toast.fail('相册中暂无照片')
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.container {
  margin: 20px 17px 30px;
  padding: 10px 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 4px #efefef;

  .box {
    .box-title {
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      color: #4d4d4d;
      border-bottom: 3px solid #d9a436;
    }

    .box-content {
      .list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 25px;
        // margin-bottom: 30px;
        .item {
          width: 145px;
          height: 85px;
          margin-bottom: 20px;
          margin-right: 20px;

          video {
            width: 100%;
            height: 100%;
            background: #111;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item:nth-child(2n) {
          margin-right: 0px;
        }
      }

      .photo-list {
        .item {
          height: 102px;
          background: url('~@/assets/images/hall-photo-bg.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          .normal {
            width: 88%;
            height: 88%;
            object-fit: cover;
          }

          .thumbnail {
            object-fit: contain;
          }
        }
      }
    }

    .noData {
      margin-bottom: 10px;
      text-align: center;
      color: #bbb;
    }
  }

  .mv-container {
    margin-top: 10px;
    margin-bottom: 15px;
  }
}

.button-box {
  padding-bottom: 70px;

  .btn {
    height: 49px;
    line-height: 49px;
    background: $primary-color;
    font-size: 17px;
    color: #fff;
    text-align: center;
  }
}
</style>
